export const NAMESPACE = {
  dataSelectedSpecialityId: 'data-selected-speciality-id',
} as const
